import { ref } from '@vue/runtime-dom'
// 是否处理
export enum isDealwith {
  未处理 = 0,
  已处理 = 1,
  未处理已人车分离 = 2
}
// 缴费状态
export enum isPayment {
  未缴款 = 0,
  已缴款 = 1,
  无需缴款 = 9
}
// 处理状态更新
export enum dealUpdate {
  未更新 = 1,
  已更新 = 2,
  已同步 = 3
}
// 同步类型
export enum syncType {
  未同步 = 1,
  已同步 = 2,
  无需同步 = 3
}
// 同步开放API：1-已推送 2-未推送 3-无需推送
export enum pushOpenApi {
  已推送 = 1,
  未推送 = 2,
  无需推送 = 3
}
// 更新开放API：1-未更新 2-已更新 3-已同步
export enum updateOpenApi {
  未更新 = 1,
  已更新 = 2,
  已同步 = 3
}

export const getTableConfig = () => {
  // table 通用属性
  const common = {
    // table 有多选时设置
    isSelection: false,
    // table loading
    loading: false,
    // table 是否为斑马纹
    stripe: true,
    // table 的尺寸 medium / small / mini
    size: 'small',
    // table 是否开启索引
    isIndex: true,
    // // table 索引 label
    indexLabel: '序号',
    // table 数据
    data: []
  }

  // table 分页
  const pagination = {
    // 是否展示分页
    isShow: true,
    // 总条数
    total: 0,
    // 每页显示条目个数
    pageSize: 20,
    // 当前页数
    currentPage: 1,
    // 每页显示个数选择器的选项设置
    pageSizes: [10, 20, 40, 80, 100]
  }

  // table 列数据
  const column = [
    {
      key: 'orgName',
      label: '资产公司',
      width: '140'
    },
    {
      key: 'violationNo',
      label: '违章编号',
      width: '140'
    },
    {
      key: 'carId',
      label: '车牌号',
      width: '100'
    },
    {
      key: 'carType',
      label: '车牌类型',
      width: '130'
    },
    {
      key: 'violationInfo',
      label: '违章信息',
      width: '160'
    },
    {
      key: 'violationLocation',
      label: '违章地点',
      width: '160'
    },
    {
      key: 'violationTime',
      label: '违章时间',
      width: '160'
    },
    {
      key: 'score',
      label: '扣分',
      width: '50'
    },
    {
      key: 'fine',
      label: '罚款',
      width: '50'
    },
    {
      key: 'collectionDepartment',
      label: '采集部门',
      width: '140'
    },
    {
      key: 'isDealwith',
      label: '是否处理',
      width: '100',
      slot: 'isDealwith'
    },
    {
      key: 'isPayment',
      label: '缴费状态',
      width: '100',
      slot: 'isPayment'
    },
    {
      key: 'createTime',
      label: '创建时间',
      width: '160'
    },
    {
      key: 'dealUpdate',
      label: '处理状态更新',
      width: '100',
      slot: 'dealUpdate'
    },
    {
      key: 'syncType',
      label: '同步类型',
      width: '100',
      slot: 'syncType'
    },
    {
      key: 'pushOpenApi',
      label: '同步开放API',
      width: '120',
      slot: 'pushOpenApi'
    },
    {
      key: 'updateOpenApi',
      label: '更新开放API',
      width: '120',
      slot: 'updateOpenApi'
    },
    {
      key: 'imgs',
      label: '照片信息',
      width: '140',
      slot: 'imgs'
    },
  ]

  return {
    ...common,
    pagination,
    column
  }
}

// 搜索配置
export const inputList = (remoteData1: any, remoteData2: any) => [
  {
    type: 'select',
    label: '资产公司',
    key: 'settingId',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200,
    maxlength: 50,
    options: remoteData1.options,
    isLoading: remoteData1.isLoading,
    isRemote: true,
    isMultiple: false,
    isFilterable: true,
    isCollapseTags: false,
    remoteMethod: remoteData1.remoteMethod,
    rules: {
    }
  },
  {
    type: 'select',
    label: '车牌号',
    key: 'carId',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200,
    maxlength: 8,
    options: remoteData2.options,
    isLoading: remoteData2.isLoading,
    isRemote: true,
    isMultiple: false,
    isFilterable: true,
    isCollapseTags: false,
    remoteMethod: remoteData2.remoteMethod,
    rules: {
    }
  },
  {
    type: 'datePicker',
    dateType: 'daterange',
    label: '违章时间',
    key: 'violationStartTime',
    placeholder: '请输入',
    format: 'YYYY-MM-DD',
    itemShow: true,
    labelWidth: 110,
    inputWidth: 280,
    isArea: true, // 是否开启这功能，默认关闭，兼容以前
    keyList: ['violationTimeStart', 'violationTimeEnd'], // 开始，结束时间字段
    formatList: ['YYYY-MM-DD 00:00:00', 'YYYY-MM-DD 23:59:59'], // 开始，结束时间格式
    startPlaceholder: '违章开始日期',
    endPlaceholder: '违章结束日期'
  }
]

// 页面搜索和基础变量
export const getIndexConfig = () => {
  // 页面基础变量
  const page = {
    queryForm: ref<any>({}), // 搜索参数
    visible: false,
    rowData: null,
    determine: false,
    title: ''
  }
  return {
    ...page
  }
}